<script setup lang="ts">
import AppButton from "~/components/Common/Buttons/AppButton.vue";
import {
  trainingReviewMatchSegmentsOf,
  trainingReviewOpenLabelOf,
  trainingReviewSummaryOf,
} from "~/utils/helpers/copilot/training-review";
import type { ICopilotTrainingReview } from "~/utils/interfaces/copilot-interfaces";

/**
 * Output of the `reviewTraining` tool. The form never opens by itself: this is the only way in, so
 * the admin leaves the conversation when they choose and no second draft is ever created behind them.
 *
 * It is also the whole answer — the recap and the assistant's prose are dropped beside it — so an
 * update has to name the fiche it recognised here, or the CTA asks for a write against a training
 * nothing on screen identifies.
 */
const props = defineProps<{
  review: ICopilotTrainingReview;
}>();

const emit = defineEmits<{
  open: [review: ICopilotTrainingReview];
}>();

const matchSegments = computed(() => trainingReviewMatchSegmentsOf(props.review));
const summary = computed(() => trainingReviewSummaryOf(props.review));
const label = computed(() => trainingReviewOpenLabelOf(props.review));
</script>

<template>
  <div class="flex flex-col gap-3">
    <!-- The fiche's own words carry the emphasis; the sentence around them does not. -->
    <span v-if="matchSegments" class="body_regular text-primary-color">
      <span v-for="(segment, index) of matchSegments" :key="index" :class="{ body_demi: segment.strong }">{{
        segment.text
      }}</span>
    </span>

    <span class="body_regular text-primary-color">{{ summary }}</span>

    <AppButton class="w-full" :label="label" icon="arrow_right" reverse-icon @click="emit('open', review)" />
  </div>
</template>
